import FileOutlineIcon from '@eduzz/houston-icons/FileOutline';
import TrashOutlineIcon from '@eduzz/houston-icons/TrashOutline';
import IconButton from '@eduzz/houston-ui/IconButton';
import List from '@eduzz/houston-ui/List';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { loadFile } from 'store/Orbita/Product/actions';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any> {
  file: any;
  onRemove: any;
  index: any;
  itemIndex: any;
  fileName: any;
}

interface IStates {
  fileName: any;
}

class File extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);
    this.state = { fileName: null };
    if (this.props.file && !this.props.file.name) {
      (async () => {
        await this.props.dispatch(loadFile(this.props.file));
        this.setState({ fileName: this.props.fileName });
      })();
    }
    this.nameFile = this.nameFile.bind(this);
  }
  nameFile = (file: any) => {
    if (file && !file.name) {
      let { fileName } = this.state;
      return fileName && fileName.name ? `${fileName.name}.${fileName.extension}` : 'Carregando...';
    }
    return file.name;
  };

  render() {
    const { file, onRemove, index, itemIndex } = this.props;
    if (file?.name) return null;
    return (
      <List.Item>
        <List.Left>
          <FileOutlineIcon />
        </List.Left>
        <List.Text description={this.nameFile(file)} title='Arquivo' />

        <List.Right>
          <IconButton onClick={() => onRemove(this.nameFile(file), itemIndex, index)}>
            <TrashOutlineIcon />
          </IconButton>
        </List.Right>
      </List.Item>
    );
  }
}
function mapStateToProps(state: any) {
  return {
    fileName: state.orbita.Product.file,
  };
}

export default connect(mapStateToProps)(File);
